<div class="qr-code-wrapper">
  <div class="payment-header position-relative mx-auto pl-3 pt-2 theme-interface">
    <div class="theme-light">
      <a href="#"
         class="close-details d-flex m-1 arrow-icon position-absolute container-theme-light-icons round-background"
         (click)="onGoBack($event)">
        <i class="fa fa-arrow-left m-auto"></i>
      </a>
      <div class="text-center font-size-header font-weight-bold">{{'public.checkout.payment' | translate}}</div>
      <div class="payment-title d-block m-1 mt-3 text-center pb-2 font-size-primary theme-light-subtitle">
        {{'public.checkout.payUsingQrCode' | translate}}
      </div>
    </div>
    <app-store-catalog-language-selector [haveBackground]="false"></app-store-catalog-language-selector>
  </div>
  <div class="qr-image-container">
    <div class="qr-code-image">
      <app-qr-code-image [storeId]="storeId" [data]="qrCodePaymentUrl"></app-qr-code-image>
    </div>
  </div>
</div>
